export default () => {
  const postMoreButton = document.querySelector('.c-posts-list__more');
  const postsContainer = document.querySelector('.c-posts-list__items');

  if (postMoreButton !== null && postsContainer !== null) {
    let postsLoading = false;

    postMoreButton.addEventListener('click', event => {
      event.preventDefault();
      if (postsLoading) {
        return;
      }
      postsLoading = true;

      const xhr = new XMLHttpRequest();
      xhr.addEventListener('load', () => {
        postsLoading = false;

        if (xhr.status === 200) {
          const fakeHTML = document.createElement('html');
          fakeHTML.innerHTML = xhr.responseText;
          const newPostContainer = fakeHTML.querySelector(
            '.c-posts-list__items',
          );

          if (newPostContainer !== null) {
            postsContainer.insertAdjacentHTML(
              'beforeend',
              newPostContainer.innerHTML,
            );
          }

          const newMoreButton = fakeHTML.querySelector('.c-posts-list__more');
          if (newMoreButton === null) {
            postMoreButton.parentNode.removeChild(postMoreButton);
          } else {
            postMoreButton.setAttribute(
              'href',
              newMoreButton.getAttribute('href'),
            );
          }
        }
      });
      xhr.open('GET', postMoreButton.getAttribute('href'));
      xhr.send();
    });
  }
};



// WEBPACK FOOTER //
// ./src/scripts/modules/buttons.js